import styled from 'styled-components';

const Footer = styled.form`
  position: relative;
  width: 90%;
  margin: -15px auto 20px auto;
`;

export default Footer;
